import { ajaxPostJson, ajaxGetJson } from './ajax';
const bilingualAlignmentAjax = {
  // 对齐记录分页
  queryBatchRecordPage(params) {
    return ajaxPostJson(`/bilingual/queryBatchRecordPage`, params, 'BaseApi')
  },
  // 删除对齐记录
  deleteAlignRecord(params) {
    return ajaxPostJson(`/bilingual/deleteAlignRecord`, params, 'BaseApi')
  },
  // 对齐记录单个下载
  exportAlignFile(params) {
    return ajaxPostJson(`/bilingual/exportAlignFile`, params, 'BaseApi')
  },
  // 下载轮询
  getDownloadAsyncResultV2(params) {
    return ajaxGetJson(`/file/getDownloadAsyncResultV2?taskKey=${params.taskKey}`, params, 'BaseApi')
  },
  //    批量修改双语对齐批次库明细
  batchUpdateBilingualSent: (params) => {
    return ajaxPostJson(`/bilingual/batchUpdateBilingualSent`, params, 'BaseApi')
  },
  //    上传文件
  uploadFileByHost: (url, data, config) => {
    return request({
      method: 'POST',
      url,
      data,
    })
  },
  //添加批次明细到记忆库
  addBatchSendMemory: (params) => {
    return ajaxPostJson(`/bilingual/addBatchSendMemory`, params, 'BaseApi')
  },
  //    添加双语对齐批次库明细
  addBilingualSent: (params) => {
    return ajaxPostJson(`/bilingual/addBilingualSent`, params, 'BaseApi')
  },
  //    删除全部批次明细
  batchDeleteAll: (params) => {
    return ajaxPostJson(`/bilingual/batchDeleteAll`, params, 'BaseApi')
  },
  //    批量删除批次明细
  batchDeleteByIdList: (params) => {
    return ajaxPostJson(`/bilingual/batchDeleteByIdList`, params, 'BaseApi')
  },
  //    根据分组id统计空行数量
  countBlankSent: (params) => {
    return ajaxPostJson(`/bilingual/countBlankSent`, params, 'BaseApi')
  },
  //    删除重复句子
  deleteRepeatSent: (params) => {
    return ajaxPostJson(`/bilingual/deleteRepeatSent`, params, 'BaseApi')
  },
  //    交换源语言和目标语言
  exchangeSourceTarget: (params) => {
    return ajaxPostJson(`/bilingual/exchangeSourceTarget`, params, 'BaseApi')
  },
  //    获取上传签名等信息
  getUploadSign: (params) => {
    return ajaxPostJson(`/bilingual/getUploadSign`, params, 'BaseApi')
  },
  //    查询用户当前或者最后一个批次的状态
  getUserLastBatch: (params) => {
    return ajaxPostJson(`/bilingual/getUserLastBatch`, params, 'BaseApi')
  },
  //    合并
  mergeBilingualSent: (params) => {
    return ajaxPostJson(`/bilingual/mergeBilingualSent`, params, 'BaseApi')
  },
  //    移动
  moveBilingualSent: (params) => {
    return ajaxPostJson(`/bilingual/moveBilingualSent`, params, 'BaseApi')
  },
  //    获取语言对列表
  queryLangList: (params) => {
    return ajaxPostJson(`/bilingual/queryLangList`, params, 'BaseApi')
  },
  //语言检测
  fileLanguage: (params) => {
    return ajaxPostJson(`/file/language`, params, 'BaseApi')
  },
  // 分页查询项目列表
  queryPage: (params) => {
    return ajaxPostJson(`/bilingual/queryPage`, params, 'BaseApi')
  },
  //    新建批次
  save: (params) => {
    return ajaxPostJson(`/bilingual/save`, params, 'BaseApi')
  },
  //    拆分
  spiltBilingualSent: (params) => {
    return ajaxPostJson(`/bilingual/spiltBilingualSent`, params, 'BaseApi')
  },
  //    修改双语对齐批次库明细
  updateBilingualSent: (params) => {
    return ajaxPostJson(`/bilingual/updateBilingualSent`, params, 'BaseApi')
  },
  // 获取领域
  getTerritory: (params) => {
    return ajaxPostJson(`/common/queryOptionList`, params, 'BaseApi')
  },
  // 修改保存状态
  updateBatchSendMemoryStatus: (params) => {
    return ajaxPostJson(`/bilingual/updateBatchSendMemoryStatus`, params, 'BaseApi')
  }
}
export default bilingualAlignmentAjax